import { QuestionDigitalDto } from '@/data/http/impact-co2/questions/digital/dto.type.ts';
import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  ImpactCo2Answer,
  Source,
  SourceValues,
  ValuesDigital,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

export class QuestionDigitalMapper {
  static dtoToEntity(dto: QuestionDigitalDto): ImpactCo2Answer<ValuesDigital> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'DIGITAL',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        dataUsage: Number.parseFloat(dto.dataUsage.toString()),
        videoViews: Number.parseFloat(dto.videoViews.toString()),
        label: dto.label || '',
        score: dto.score || 0,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesDigital>,
    projectId: number,
  ): Omit<QuestionDigitalDto, 'id' | 'userId' | 'score' | 'isExternal'> {
    return {
      projectId: projectId,
      sector: answer.sector,
      dataUsage: answer.values.dataUsage,
      videoViews: answer.values.videoViews,
      label: answer.values.label || '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
